import { Box, Typography, Paper, Stack } from '@mui/material'
import Spinner from 'components/spinner/Spinner'
import RoundIconButton from 'components/roundIconButton/RoundIconButton'
import RefreshIcon from '@mui/icons-material/Refresh'
import { SearchStatus } from 'store/commonTypes'
import RegenerateReportSection from 'containers/dashboard/singleReportPage/components/RegenerateReportSection'

type Props = {
  status: SearchStatus | null
  isAdmin?: boolean
  searchId: string
}

export default function ReportLoading({ status, isAdmin, searchId }: Props) {
  const getLoadingMessage = () => {
    switch (status) {
      case 'search_finished':
        return {
          title: 'Starting report generation',
          subtitle: 'Please wait...',
        }
      case 'report_compiling':
        return {
          title: 'Report is being compiled',
          subtitle: 'We are processing the information. This may take a few minutes...',
        }
      default:
        return {
          title: 'Loading',
          subtitle: 'Please wait...',
        }
    }
  }

  const message = getLoadingMessage()

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh',
        py: 4,
      }}>
      <Paper
        elevation={0}
        sx={{
          p: 6,
          borderRadius: '20px',
          width: '600px',
          textAlign: 'center',
          border: '1px solid',
          borderColor: 'divider',
        }}>
        <Stack spacing={3} alignItems="center">
          <Spinner size={60} />

          <Typography variant="h5" color="primary" fontWeight={500}>
            {message.title}
          </Typography>

          <Typography variant="body1" color="text.secondary">
            {message.subtitle}
          </Typography>

          {isAdmin && (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                p: 3,
                borderTop: '1px solid',
                borderColor: 'divider',
                width: '100%',
              }}>
              <Box mb={1}>
                <Typography variant="body1" color="text.secondary" fontWeight={'bold'}>
                  Bo admin only
                </Typography>
              </Box>
              <Box mb={2}>
                <Typography variant="body2" color="text.secondary">
                  Status: {status}
                </Typography>
              </Box>

              <RegenerateReportSection searchId={searchId} />
            </Box>
          )}
        </Stack>
      </Paper>
    </Box>
  )
}
